const isCableURL = (): boolean => {
  return window.location.pathname.includes("cable");
};

export default isCableURL;
